import { UiCategory, UiCategoryExt } from '../types';

import { HeaderServiceResponse, HeaderContentImpl, Environment } from './types';

export function isInSameCategoryTree(
    categoryPath: string,
    highlightPath?: string,
): boolean {
    let active = false;

    if (highlightPath?.startsWith(categoryPath)) {
        active = true;
        const hightlightPathArr = highlightPath.split('/');
        categoryPath.split('/').forEach((categoryPathValue, index) => {
            if (categoryPathValue !== hightlightPathArr[index]) {
                active = false;
            }
        });
    }
    return active;
}

function convertUiCategory(
    category: UiCategory,
    highlightPath?: string,
): UiCategoryExt {
    function mapToExt(categories: UiCategory[] | undefined) {
        return categories?.map((child) =>
            convertUiCategory(child, highlightPath),
        );
    }

    return {
        ...category,
        active: isInSameCategoryTree(category.path, highlightPath),
        children: mapToExt(category.children),
        specials: mapToExt(category.specials),
        hasMore: category.hasMore ?? false,
    };
}

export function convertToHeaderContent({
    headerServiceResponse,
    isNextJS,
    environment,
    highlightPath,
}: {
    headerServiceResponse: HeaderServiceResponse;
    isNextJS: boolean;
    environment: Environment;
    highlightPath?: string;
}): HeaderContentImpl {
    return {
        ...headerServiceResponse,
        deployStage: environment,
        categories:
            headerServiceResponse.categories?.map((category) =>
                convertUiCategory(category, highlightPath),
            ) ?? [],
        isNextJS,
    };
}
